export default {
      id: "insurer-group-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#insurer-group",
      toString: function () {
        return this.url;
      }
    }